var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDasha = function SvgDasha(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1BD",
    fillRule: "evenodd",
    d: "M9 7c0-2.043-1.691-3.723-3.784-3.75H3a.75.75 0 0 0-.75.75v6c0 .414.336.75.75.75h2.187C7.31 10.723 9 9.043 9 7m2.25 0c0 3.287-2.694 5.957-6.034 6H3a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3h2.216c3.34.043 6.034 2.713 6.034 6",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1BD",
    fillRule: "evenodd",
    stroke: "#1B1B2D",
    d: "M10.125 4.75a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDasha);
export { ForwardRef as ReactComponent };